let question : string = "";
let answer : string = "";

export class IntakeService {
  public static setQuestion(value : string) {
    question = value || "";
  }

  public static setAnswer(value : string) {
    answer = value || "";
  }

  public static getQuestionAndAnswer() {
      return (question && question != "" ? question + "\r\n\r\n" : "") + (answer || "");
  }
}